var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-container',{ref:"contain"},[_c('ArtisanGrid',{ref:"sysMetaColumn",attrs:{"metaKey":"SysMetaColumn","query":_vm.query}},[_c('template',{slot:"gridBtnAfter"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-copy-document"},on:{"click":_vm.autoCreate}},[_vm._v("自动生成")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }